import {
  SETTINGS,
  COST_CENTER,
  ACC_SETUP,
  FINANCIAL_YEAR,
  OPENING_BALANCE,
  GL_MAP,
  ACC_TYPE,
  VOUCHER_APPROVAL_WORKFLOW,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

export const SettingsRoutes: IAppRoutes = {
  link: SETTINGS,
  childrens: [
    {
      link: COST_CENTER,
      element: guard(() => import('@modules/settings/cost-center'), [COST_CENTER]),
    },
    {
      link: ACC_TYPE,
      element: guard(() => import('@modules/settings/acc-type'), [ACC_TYPE]),
    },
    {
      link: ACC_SETUP,
      element: guard(() => import('@modules/settings/acc-setup'), [ACC_SETUP]),
    },
    {
      link: FINANCIAL_YEAR,
      element: guard(() => import('@modules/settings/financial-year'), [FINANCIAL_YEAR]),
    },
    {
      link: OPENING_BALANCE,
      element: guard(() => import('@modules/settings/opening-balance'), [OPENING_BALANCE]),
    },
    {
      link: GL_MAP,
      element: guard(() => import('@modules/settings/gl-map'), [GL_MAP]),
    },
    {
      link: VOUCHER_APPROVAL_WORKFLOW,
      element: guard(() => import('@modules/settings/approval-workflow'), [VOUCHER_APPROVAL_WORKFLOW]),
    },
  ],
}
